'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = angular.module("winresCloudWebComponents", [
//'ui.select',
//'ui.select2',
'ui.bootstrap', 'jm.i18next', 'rt.select2', 'ngMessages', 'ngSanitize', 'rzModule', 'duScroll', 'daterangepicker', 'angular-google-analytics', 'ui.router', 'winresCloud.core', 'winresCloud.winresCloud', 'winresCloud.reservation', 'winresCloud.environment']);


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/module.js
// module id = 271
// module chunks = 2